import { Badge } from '@cloudscape-design/components';
import { LotKinds } from '@parallel-fluidics/shared/constants';
import PropTypes from 'prop-types';
import React from 'react';

const LotKindColorMap = Object.freeze({
  [LotKinds.INHOUSE]: 'blue',
  [LotKinds.ASSEMBLED]: 'green',
  [LotKinds.PURCHASED]: 'grey',
});

export default function LotKindBadge({ kind = null }) {
  return (
    <Badge color={LotKindColorMap[kind] || 'grey'}>
      {kind || 'unknown'}
    </Badge>
  );
}

LotKindBadge.propTypes = {
  kind: PropTypes.oneOf(Object.values(LotKinds)),
};
